import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import { submitForm } from "../../Helpers/API/formsAPI";
import { getRegionConfig } from "./config/regionConfig";

function CanEngage({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({ engagement: false });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({
      ...prev,
      [name]: value
    }));

    if (isError[name]) {
      setIsError(prev => ({ ...prev, [name]: false }));
    }
  };

  const validateForm = () => {
    const errors = { engagement: !primaryDetails.engagement };
    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please select an option", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return !!primaryDetails.engagement;
  };
  const handleNext = () => {
    if (!validateForm()) return;

    if (
      primaryDetails.engagement === "Cannot engage but merchant has Maya terminal or Maya SQR" ||
      primaryDetails.engagement === "Cannot engage, merchant has NO Maya terminal and NO Maya SQR"
    ) {
      navigation.go("cant-engage-remarks");
    } else {
      navigation.go("type-of-merchant");
    }
  };

  const handleBack = () => {
     navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">CAN ENGAGE?</h4>
              <p className="form-desc">Please select whether you can engage with this merchant</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  <Form.Group className="mb-5" controlId="engagement">
                    <Form.Label className="form-label">
                      Can Engage? <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {[
                        { value: "Yes", label: "Yes" },
                        { value: "Cannot engage but merchant has Maya terminal or Maya SQR", label: "Cannot engage but merchant has Maya terminal or Maya SQR" },
                        { value: "Cannot engage, merchant has NO Maya terminal and NO Maya SQR", label: "Cannot engage, merchant has NO Maya terminal and NO Maya SQR" }
                      ].map((option, index) => (
                        <div
                          key={`can-engage-${index}-${option.value}`}
                          className={`form-radio-item${primaryDetails.engagement === option.value ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="engagement"
                              value={option.value}
                              label={option.label}
                              onChange={handleInputChange}
                              checked={primaryDetails.engagement === option.value}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {isError.engagement && <div className="form-error">Please select an option</div>}
                  </Form.Group>

                  <div className="form-btn-row">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back
                    </AppButton>
                    <AppButton onClick={handleNext} variant="next" className="form-btn variant-primary" disabled={!isFormValid()}>
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CanEngage;
